import { ArrowBackIosNew, Close } from '@project-lary/react-material-symbols';
import IconButton from 'gcs-common/design-system/ui/icon-button';

type PanelHeaderProps = {
  title: string;
  onBack?: VoidFunction;
  onClose?: VoidFunction;
};

const PanelHeader = (props: PanelHeaderProps) => {
  const { title, onClose, onBack } = props;
  return (
    <div className="box-border flex h-[76px] flex-row items-center border-0 border-neutral-7 border-b border-solid p-4">
      {onBack ? (
        <div className="flex flex-1 justify-start">
          <button>
            <IconButton
              Icon={ArrowBackIosNew}
              iconSize="size-6"
              className="cursor-pointer"
              size="m"
              variant="ghost_neutral"
              onClick={onBack}
            />
          </button>
        </div>
      ) : (
        <div className="flex-1" />
      )}
      <div className="text-center text-base">{title}</div>
      {onClose ? (
        <div className="flex flex-1 justify-end">
          <button>
            <IconButton
              Icon={Close}
              iconSize="size-6"
              className="cursor-pointer"
              size="m"
              variant="ghost_neutral"
              onClick={onClose}
            />
          </button>
        </div>
      ) : (
        <div className="flex-1" />
      )}
    </div>
  );
};

export default PanelHeader;
